'use strict';

var React = require('react');
var classNames = require('classnames');
var PlaidDecorator = require('@piconetworks/plaid-decorator');
var Form = require('@piconetworks/form');
var heading = require('@piconetworks/heading');
var CardBrandImage = require('@piconetworks/card-brand-image');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);
var PlaidDecorator__default = /*#__PURE__*/_interopDefaultLegacy(PlaidDecorator);
var Form__default = /*#__PURE__*/_interopDefaultLegacy(Form);
var CardBrandImage__default = /*#__PURE__*/_interopDefaultLegacy(CardBrandImage);

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (_i = _i.call(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var styles = {"paymentForm":"Payment-module_paymentForm__rVd4F","paymentDetails":"Payment-module_paymentDetails__1mwYk","existingPaymentMethods":"Payment-module_existingPaymentMethods__3Eioj","savedPayment":"Payment-module_savedPayment__Vxe7I","cardDetails":"Payment-module_cardDetails__3aFIu","cardDescription":"Payment-module_cardDescription__5bJkN","cardNumber":"Payment-module_cardNumber__2BNVG","cardMask":"Payment-module_cardMask__1CZHZ","cardExpiration":"Payment-module_cardExpiration__2jVaV","paymentHeader":"Payment-module_paymentHeader__1Ghlh","iconLock":"Payment-module_iconLock__3oh5e","paymentFormArea":"Payment-module_paymentFormArea__2tl0P","groupContainer":"Payment-module_groupContainer__wEXY9","inputContainer":"Payment-module_inputContainer__2zth0"};

var RadioOption = function RadioOption(_ref) {
  var linkColor = _ref.linkColor,
      name = _ref.name,
      value = _ref.value,
      children = _ref.children,
      _onChange = _ref.onChange,
      radioGroupValue = _ref.radioGroupValue;
  return /*#__PURE__*/React__default['default'].createElement(Form__default['default'].Radio, {
    checked: radioGroupValue === value,
    color: linkColor,
    input: {
      checked: radioGroupValue === value,
      name: name,
      onChange: function onChange(e) {
        _onChange(e);
      },
      type: "radio",
      value: value
    },
    name: name,
    text: children,
    type: "radio",
    value: value
  });
};

var ExistingPaymentMethods = function ExistingPaymentMethods(_ref2) {
  var _ref2$paymentMethods = _ref2.paymentMethods,
      paymentMethods = _ref2$paymentMethods === void 0 ? [] : _ref2$paymentMethods,
      onChange = _ref2.onChange,
      radioGroupValue = _ref2.radioGroupValue,
      linkColor = _ref2.linkColor,
      _ref2$deleteCard = _ref2.deleteCard,
      deleteCard = _ref2$deleteCard === void 0 ? function () {} : _ref2$deleteCard;
  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, paymentMethods.map(function (_ref3) {
    var name = _ref3.name,
        cardType = _ref3.cardType,
        id = _ref3.id,
        expirationMonth = _ref3.expirationMonth,
        expirationYear = _ref3.expirationYear,
        last4 = _ref3.last4;
    return /*#__PURE__*/React__default['default'].createElement("div", {
      className: styles.savedPayment
    }, /*#__PURE__*/React__default['default'].createElement(RadioOption, {
      key: id,
      linkColor: linkColor,
      name: name,
      value: id,
      onChange: onChange,
      radioGroupValue: radioGroupValue
    }, /*#__PURE__*/React__default['default'].createElement("div", {
      className: styles.cardDetails
    }, /*#__PURE__*/React__default['default'].createElement(CardBrandImage__default['default'], {
      brand: cardType ? cardType.toLowerCase().replace(/\s/g, '').trim() : ''
    }), /*#__PURE__*/React__default['default'].createElement("div", {
      className: styles.cardDescription
    }, /*#__PURE__*/React__default['default'].createElement("div", {
      className: styles.cardNumber
    }, /*#__PURE__*/React__default['default'].createElement("div", null, cardType), /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement("span", {
      className: styles.cardMask
    }, "\u2022", "\u2022", "\u2022", "\u2022"), last4)), /*#__PURE__*/React__default['default'].createElement("div", {
      className: styles.cardExpiration
    }, "Expires ", expirationMonth, "/", expirationYear)))), /*#__PURE__*/React__default['default'].createElement("svg", {
      onClick: function onClick(e) {
        e.preventDefault();
        e.stopPropagation();
        deleteCard(id);
      },
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24"
    }, /*#__PURE__*/React__default['default'].createElement("title", null, " icon_delete"), /*#__PURE__*/React__default['default'].createElement("g", {
      fill: "none"
    }, /*#__PURE__*/React__default['default'].createElement("g", {
      fill: "#FF4440"
    }, /*#__PURE__*/React__default['default'].createElement("path", {
      d: "M6 18.5C6 19.6 6.9 20.5 8 20.5L16 20.5C17.1 20.5 18 19.6 18 18.5L18 9.5 6 9.5 6 18.5ZM17 4.5L15.5 4.5 15.5 4.5 15.1 4.1C14.7 3.7 14.2 3.5 13.7 3.5L10.3 3.5C9.8 3.5 9.3 3.7 8.9 4.1L8.5 4.5 8.5 4.5 7 4.5C5.9 4.5 5 5.4 5 6.5L5 7.5 5 7.5 19 7.5 19 6.5C19 5.4 18.1 4.5 17 4.5Z"
    })))));
  }));
};

var AddNewBankAccount = function AddNewBankAccount(_ref4) {
  var PlaidLink = _ref4.PlaidLink,
      onChange = _ref4.onChange,
      style = _ref4.style,
      radioGroupValue = _ref4.radioGroupValue;
  return /*#__PURE__*/React__default['default'].createElement(RadioOption, {
    name: 'paymentMethods',
    value: 'add_bank_account',
    onChange: onChange,
    style: style,
    radioGroupValue: radioGroupValue
  }, /*#__PURE__*/React__default['default'].createElement(PlaidLink, null, "Add new bank account"));
};

var AddNewCard = function AddNewCard(_ref5) {
  var CardElement = _ref5.CardElement,
      linkColor = _ref5.linkColor,
      onChange = _ref5.onChange,
      style = _ref5.style,
      radioGroupValue = _ref5.radioGroupValue,
      _ref5$value = _ref5.value,
      value = _ref5$value === void 0 ? 'add_card' : _ref5$value,
      _ref5$onComplete = _ref5.onComplete,
      onComplete = _ref5$onComplete === void 0 ? function () {} : _ref5$onComplete,
      _ref5$onError = _ref5.onError,
      onError = _ref5$onError === void 0 ? function () {} : _ref5$onError,
      _ref5$onIncomplete = _ref5.onIncomplete,
      onIncomplete = _ref5$onIncomplete === void 0 ? function () {} : _ref5$onIncomplete;
  var showStripeElement = radioGroupValue === value;
  var cardRef = React.useRef(null);

  function changeBorderColor(ref, linkColor) {
    var el = ref.current;

    if (!el) {
      return;
    }

    el.style.borderColor = linkColor ? linkColor : '#dddddd';
  }

  var inputItemOptions = {
    style: {
      base: {
        color: '#444444',
        fontSmoothing: 'antialiased',
        fontSize: '16px',
        '::placeholder': {
          color: '#DDDCE0'
        }
      },
      invalid: {
        color: '#FF5E5B',
        iconColor: '#FF5E5B'
      }
    }
  };
  return /*#__PURE__*/React__default['default'].createElement(RadioOption, {
    name: 'paymentMethods',
    value: value,
    onChange: onChange,
    style: style,
    radioGroupValue: radioGroupValue,
    linkColor: linkColor
  }, "Add new card", showStripeElement && /*#__PURE__*/React__default['default'].createElement("div", {
    className: styles.paymentFormArea
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNames__default['default'](styles.groupContainer)
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: styles.inputItem
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    ref: cardRef,
    className: styles.inputContainer
  }, /*#__PURE__*/React__default['default'].createElement(CardElement, {
    onReady: function onReady(e) {
      e.focus();
      onIncomplete();
    },
    onChange: function onChange(event) {
      if (event.complete) {
        onComplete();
      } else if (event.error) {
        onError(event.error);
      } else {
        onIncomplete();
      }
    },
    options: inputItemOptions,
    onFocus: function onFocus() {
      return changeBorderColor(cardRef, linkColor);
    },
    onBlur: function onBlur() {
      return changeBorderColor(cardRef);
    }
  }))))));
};

var Payment = function Payment(_ref6) {
  var _ref6$existingPayment = _ref6.existingPaymentMethods,
      existingPaymentMethods = _ref6$existingPayment === void 0 ? [] : _ref6$existingPayment,
      _ref6$changeCompletio = _ref6.changeCompletionStatus,
      changeCompletionStatus = _ref6$changeCompletio === void 0 ? function () {} : _ref6$changeCompletio,
      isComplete = _ref6.isComplete,
      linkColor = _ref6.linkColor,
      publisherName = _ref6.publisherName,
      _ref6$defaultPaymentM = _ref6.defaultPaymentMethod,
      defaultPaymentMethod = _ref6$defaultPaymentM === void 0 ? false : _ref6$defaultPaymentM,
      _ref6$CardElement = _ref6.CardElement,
      CardElement = _ref6$CardElement === void 0 ? function () {
    return null;
  } : _ref6$CardElement,
      _ref6$enableStripe = _ref6.enableStripe,
      enableStripe = _ref6$enableStripe === void 0 ? true : _ref6$enableStripe,
      _ref6$enablePlaid = _ref6.enablePlaid,
      enablePlaid = _ref6$enablePlaid === void 0 ? false : _ref6$enablePlaid,
      sendExternalLink = _ref6.sendExternalLink,
      _ref6$deleteCard = _ref6.deleteCard,
      deleteCard = _ref6$deleteCard === void 0 ? function () {} : _ref6$deleteCard;

  var _useState = React.useState({
    selectedPaymentMethod: defaultPaymentMethod
  }),
      _useState2 = _slicedToArray(_useState, 2),
      _useState2$ = _useState2[0],
      selectedPaymentMethod = _useState2$.selectedPaymentMethod,
      selectedPaymentMethodData = _useState2$.selectedPaymentMethodData,
      selectPaymentMethod = _useState2[1];

  var _useState3 = React.useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      stripeComplete = _useState4[0],
      setStripeComplete = _useState4[1];

  changeCompletionStatus({
    isComplete: selectedPaymentMethod === 'add_card' && stripeComplete || selectedPaymentMethod !== 'add_card' && !!selectedPaymentMethod,
    selectedPaymentMethod: selectedPaymentMethod,
    selectedPaymentMethodData: selectedPaymentMethodData
  });
  var stripe_link = 'http://www.stripe.com';
  return /*#__PURE__*/React__default['default'].createElement("section", {
    className: styles.paymentForm
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: styles.paymentHeader
  }, /*#__PURE__*/React__default['default'].createElement(heading.H3, null, "Payment"), /*#__PURE__*/React__default['default'].createElement("a", {
    onClick: function onClick(e) {
      e.preventDefault();

      if (sendExternalLink) {
        sendExternalLink(stripe_link);
      } else {
        window.open(stripe_link);
      }
    },
    target: "blank",
    href: stripe_link,
    className: styles.stripeLink
  }, /*#__PURE__*/React__default['default'].createElement("svg", {
    className: styles.iconLock,
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default['default'].createElement("title", null, "icon_lock"), /*#__PURE__*/React__default['default'].createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    fill: "#28BF6F"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M17.1 10C18.2 10 19 10.8 19 11.8L19 11.8 19 20.2C19 21.2 18.2 22 17.1 22L17.1 22 6.9 22C5.8 22 5 21.2 5 20.2L5 20.2 5 11.8C5 10.8 5.8 10 6.9 10L6.9 10ZM12 12.5C10.9 12.5 10 13.4 10 14.5 10 15.3 10.5 16.1 11.3 16.4L11.3 18.8C11.3 19.2 11.6 19.5 12 19.5 12.4 19.5 12.8 19.2 12.8 18.8L12.8 18.8 12.8 16.4C13.5 16.1 14 15.3 14 14.5 14 13.4 13.1 12.5 12 12.5ZM13 2C15.2 2 17 3.8 17 6L17 10 15 10 15 6C15 4.9 14.2 4.1 13.1 4L13 4 11 4C9.9 4 9 4.9 9 6L9 6 9 10 7 10 7 6C7 3.8 8.8 2 11 2L13 2Z"
  })))), /*#__PURE__*/React__default['default'].createElement("span", null, "Processed securely by "), /*#__PURE__*/React__default['default'].createElement("svg", {
    title: "Stripe",
    icon: "M28 6.02c0-1.991-.964-3.562-2.808-3.562-1.85 0-2.97 1.57-2.97 3.546 0 2.342 1.321 3.524 3.22 3.524.925 0 1.625-.21 2.154-.506V7.467c-.53.264-1.136.427-1.906.427-.754 0-1.423-.264-1.509-1.182h3.803c0-.1.016-.505.016-.692zm-3.842-.739c0-.879.536-1.244 1.026-1.244.475 0 .98.365.98 1.244zm-4.94-2.823c1.362 0 2.645 1.229 2.653 3.484 0 2.466-1.268 3.586-2.66 3.586-.684 0-1.097-.288-1.377-.49l-.007 2.2-1.945.413V2.582h1.711l.101.482a2.197 2.197 0 0 1 1.525-.606zm-.466 5.359c.716 0 1.198-.778 1.198-1.82 0-1.02-.49-1.813-1.198-1.813-.443 0-.723.156-.925.382l.007 2.885c.187.202.46.366.918.366zm-5.545-5.818V.412L15.159 0v1.579zm0 .591h1.952v6.806h-1.952zm-2.093.576c.46-.84 1.37-.67 1.618-.576v1.789c-.24-.086-1.019-.195-1.478.404v4.613H9.31V2.59h1.68zM7.226.902L7.218 2.59h1.478v1.657H7.218v2.76c0 1.152 1.229.794 1.478.693v1.579c-.257.14-.724.257-1.362.257-1.15 0-2.014-.848-2.014-2l.008-6.23zM1.968 4.566c0 .87 2.963.458 2.97 2.776 0 1.392-1.111 2.194-2.73 2.194-.668 0-1.4-.133-2.122-.444v-1.85c.653.357 1.477.621 2.123.621.435 0 .747-.116.747-.474C2.956 6.463 0 6.806 0 4.659c0-1.377 1.05-2.201 2.629-2.201a5.13 5.13 0 0 1 1.929.358v1.827a4.338 4.338 0 0 0-1.93-.497c-.411 0-.66.116-.66.42z",
    color: "#BBB",
    display: "inline-block",
    height: "12px",
    width: "28px",
    cursor: "pointer",
    className: "clickable",
    viewBox: "0 0 28 12",
    role: "img",
    "aria-labelledby": "svg-title"
  }, /*#__PURE__*/React__default['default'].createElement("title", {
    id: "svg-title"
  }, "Stripe"), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M28 6.02c0-1.991-.964-3.562-2.808-3.562-1.85 0-2.97 1.57-2.97 3.546 0 2.342 1.321 3.524 3.22 3.524.925 0 1.625-.21 2.154-.506V7.467c-.53.264-1.136.427-1.906.427-.754 0-1.423-.264-1.509-1.182h3.803c0-.1.016-.505.016-.692zm-3.842-.739c0-.879.536-1.244 1.026-1.244.475 0 .98.365.98 1.244zm-4.94-2.823c1.362 0 2.645 1.229 2.653 3.484 0 2.466-1.268 3.586-2.66 3.586-.684 0-1.097-.288-1.377-.49l-.007 2.2-1.945.413V2.582h1.711l.101.482a2.197 2.197 0 0 1 1.525-.606zm-.466 5.359c.716 0 1.198-.778 1.198-1.82 0-1.02-.49-1.813-1.198-1.813-.443 0-.723.156-.925.382l.007 2.885c.187.202.46.366.918.366zm-5.545-5.818V.412L15.159 0v1.579zm0 .591h1.952v6.806h-1.952zm-2.093.576c.46-.84 1.37-.67 1.618-.576v1.789c-.24-.086-1.019-.195-1.478.404v4.613H9.31V2.59h1.68zM7.226.902L7.218 2.59h1.478v1.657H7.218v2.76c0 1.152 1.229.794 1.478.693v1.579c-.257.14-.724.257-1.362.257-1.15 0-2.014-.848-2.014-2l.008-6.23zM1.968 4.566c0 .87 2.963.458 2.97 2.776 0 1.392-1.111 2.194-2.73 2.194-.668 0-1.4-.133-2.122-.444v-1.85c.653.357 1.477.621 2.123.621.435 0 .747-.116.747-.474C2.956 6.463 0 6.806 0 4.659c0-1.377 1.05-2.201 2.629-2.201a5.13 5.13 0 0 1 1.929.358v1.827a4.338 4.338 0 0 0-1.93-.497c-.411 0-.66.116-.66.42z",
    fill: "#BBB"
  })))), /*#__PURE__*/React__default['default'].createElement("div", {
    className: styles.paymentDetails
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: styles.existingPaymentMethods
  }, /*#__PURE__*/React__default['default'].createElement(ExistingPaymentMethods, {
    paymentMethods: existingPaymentMethods,
    name: "paymentMethods",
    onChange: function onChange(_ref7) {
      var value = _ref7.target.value;
      selectPaymentMethod({
        selectedPaymentMethod: selectedPaymentMethod === value ? null : value
      });
    },
    radioGroupValue: selectedPaymentMethod,
    linkColor: linkColor,
    deleteCard: deleteCard
  })), enablePlaid && /*#__PURE__*/React__default['default'].createElement(PlaidDecorator__default['default'], _defineProperty({
    env: process.env.REACT_APP_PLAID_ENV,
    publicKey: process.env.REACT_APP_PLAID_PUBLIC_KEY,
    clientName: publisherName,
    onSuccess: function onSuccess() {}
  }, "onSuccess", function onSuccess(public_token) {
    var _ref8 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        account_id = _ref8.account_id;

    if (!public_token || !account_id) {
      return;
    }

    var token = {
      account_id: account_id,
      public_token: public_token
    };
    selectPaymentMethod({
      selectedPaymentMethod: 'add_bank_account',
      selectedPaymentMethodData: token
    });
  }), /*#__PURE__*/React__default['default'].createElement(AddNewBankAccount, {
    onChange: function onChange(_ref9) {
      var value = _ref9.target.value;
      selectPaymentMethod({
        selectedPaymentMethod: selectedPaymentMethod === value ? null : value
      });
    },
    radioGroupValue: selectedPaymentMethod
  })), enableStripe && /*#__PURE__*/React__default['default'].createElement(AddNewCard, {
    style: {
      width: '100%'
    },
    linkColor: linkColor,
    onChange: function onChange(_ref10) {
      var value = _ref10.target.value;
      selectPaymentMethod({
        selectedPaymentMethod: selectedPaymentMethod === value ? null : value
      });
    },
    radioGroupValue: selectedPaymentMethod,
    CardElement: CardElement,
    onComplete: function onComplete() {
      setStripeComplete(true);
    },
    onError: function onError() {
      setStripeComplete(false);
    },
    onIncomplete: function onIncomplete() {
      setStripeComplete(false);
    }
  }), /*#__PURE__*/React__default['default'].createElement("input", {
    checked: isComplete,
    type: "hidden",
    onChange: function onChange(_ref11) {
      var checked = _ref11.target.checked;
      changeCompletionStatus({
        isComplete: checked,
        selectedPaymentMethod: selectedPaymentMethod,
        selectedPaymentMethodData: selectedPaymentMethodData
      });
    }
  })));
};

module.exports = Payment;
